import React, { useEffect, useState } from "react";
import styles from "./Instructions.module.css";
import { List, Switch } from "antd";
import { Collapse, Divider } from "antd";
import { FaTrash } from "react-icons/fa";
import { GoPlus } from "react-icons/go";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import image_sample from "../../assets/instructions.png";
import LocationMiddleware from "../../store/Middlewares/LocationMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { IMG_URL } from "../../store/Apis";
import AlertAction from "../../store/Actions/AlertActions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Instructions = (data) => {
  const Data = data?.data?.state?.data

  const dispatch = useDispatch()

  const [SelectedItemIndex, setSelectedItemIndex] = useState(null)
  const [InstructionList, setInstructionList] = useState([])
  const [ShowItem, setShowItem] = useState(null)
  const [ShowSubItem, setShowSubItem] = useState(null)
  const [refresh, setrefresh] = useState(false)

  const CheckListData = useSelector(state => state.EditChecklistReducer.Checklist)


  const [Toggle, setToggle] = useState(true);
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const Tasks = [
    {
      id: 1,
      label: "Cleaning #01",
    },
    {
      id: 2,
      label: "Cleaning #02",
    },
    {
      id: 3,
      label: "Cleaning #03",
    },
    {
      id: 4,
      label: "Cleaning #04",
    },
  ];

  useEffect(() => {
    getLocationInstruction()
    // getLanguage()
    // dispatch(LocationMiddleware.getLocationsInstruction(Data?.id))
  }, [])

  const getLocationInstruction = () => {
    dispatch(LocationMiddleware.getLocationsInstruction(Data?.id))
  }

  const onPressToggelButton = (index, val) => {
    setSelectedItemIndex(index)
    for (let i = 0; i < InstructionList.length; i++) {
      if (index == i) {
        InstructionList[i].istoggled = val
        setrefresh(!refresh)
      }
      else {
        InstructionList[i].istoggled = false
        setrefresh(!refresh)
      }
    }
  }

  const onPressDelete = (index, id) => {
    // console.log(id)
    dispatch(LocationMiddleware.deleteChecklist(id))
      .then(data => {
        dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
      })
      .catch(error => console.log(error));
    CheckListData.splice(index, 1)
    setrefresh(!refresh)
  }

  const onPressDeleteSubItem = (index) => {
    InstructionList[SelectedItemIndex]?.data.splice(index, 1)
    setrefresh(!refresh)
  }

  const renderDropdownItem = (item, index) => {
    console.log('item', item)
    return (
      <div className={styles.inner_dropdown_view}>
        <div>
          <text className={styles.dropdown_text} style={{fontWeight:'bold'}}>{item?.name}</text><br/>
          <text className={styles.dropdown_text}>{item?.description}</text>
        </div>
        {item?.attachment ? <img src={IMG_URL + item?.attachment} className={styles.image} /> : null}
      </div>
    );
  };

  const renderItem = (item, index) => {
    console.log('item', item);
    return (
      <div className={styles.middle_view}>
        <Collapse size="large" bordered={false} className={styles.dropdown}>
          <Panel
            showArrow={false}
            header={
              <div className={styles.flex}>
                <div className={styles.flexB}>
                  {Toggle?.id != item?.id ? (
                    <IoIosArrowDown
                      className={styles.arrow_icon}
                      color="#ffff"
                      onClick={() => setToggle(item)}
                    />
                  ) : (
                    <IoIosArrowUp
                      className={styles.arrow_icon}
                      color="#ffff"
                      onClick={() => setToggle(null)}
                    />
                  )}
                  <text className={styles.heading}>{t(item?.name)}</text>
                </div>

                <div className={styles.flexC}>
                  <GoPlus
                    className={styles.icon}
                    color="#ffff"
                    onClick={() => navigate("/contractorHome/Location/CreateChecklist", { state: item })}
                  />
                  <FaTrash onClick={() => onPressDelete(index, item?.id)} className={styles.icon} color="#ffff" />
                  {/* <Switch
                    defaultChecked
                    style={{ backgroundColor: Toggle ? "#f6921e" : "#787887" }}
                    onChange={() => setToggle(!Toggle)}
                  /> */}
                </div>
              </div>
            }
            key="1"
            className={styles.dropdown_header}
          >
            <List dataSource={item?.items} renderItem={renderDropdownItem} />
          </Panel>
        </Collapse>
      </div>
    );
  };

  return (
    <div className={styles.mainContainer}>
      <h1 className={styles.heading}>{t("Instructions")}</h1>
      {/* <text className={styles.text}>
        Clean All the Interior , furniture and Lawn and a Clean All the floor ,
        roof and Lawn
      </text> */}

      <List dataSource={CheckListData} renderItem={renderItem} />
    </div>
  );
};

export default Instructions;
